/**
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 * !!  WARNING: Do NOT edit this file!  !!
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 *
 * Foundation components are not intended to be edited to
 * satisfy specific use cases. If you would like to propose
 * a change to this component, please reach out to a
 * frontend engineer.
 *
 * @author Asa Ayers <asa.ayers@hellosign.com>
 * @author Nathan Buchar <nathan.buchar@hellosign.com>
 */

import React from 'react';
import classnames from 'classnames';
import * as MenuButton from 'react-aria-menubutton';
import styles from './dropdown.scss';

// https://www.figma.com/file/F5nJw8rDcoLDCDH2YtOkHMd9/HelloSign---Library-(WIP)?node-id=211%3A6099
function withClass<P extends { className?: string }>(
  Component: React.ComponentType<P>, className: string,
) {
  return function WithClass(props: P) {
    return <Component {...props} className={classnames(className, props.className)} />;
  };
}

type WrapperProps = MenuButton.WrapperProps<any> & {
  // I couldn't get an enum to work, so I guess a string union is ok
  kind?: 'small' | 'large'
}

export class Wrapper<T extends HTMLElement> extends React.PureComponent<WrapperProps> {
    handleSelection = (value: any, event: React.SyntheticEvent<T>) => {
      if (this.props.onSelection) {
        this.props.onSelection(value, event);
      }
    };

    render() {
      const { kind, className, ...props } = this.props;

      return (
        <MenuButton.Wrapper
          data-qa-ref="dropdown-wrapper"
          {...props}
          onSelection={this.handleSelection}
          className={classnames(className, styles.wrapper, {
            [styles.small]: kind === 'small',
            [styles.large]: kind === 'large',
          })} />
      );
    }
}

export const Menu = withClass(MenuButton.Menu, styles.menu);

export const IconButton = withClass(MenuButton.Button, styles.iconButton);

export function Button(props: MenuButton.ButtonProps<any>) {
  return (
    <MenuButton.Button
      data-qa-ref="dropdown-btn"
      {...props}
      className={classnames(styles.button, props.className, {
        [styles.disabled]: props.disabled,
      })} />
  );
}

export function MenuItem(props: MenuButton.MenuItemProps<any>) {
  return (
    <MenuButton.MenuItem
      data-qa-ref="dropdown-item"
      {...props}
      className={classnames(styles.menuItem, props.className)} />
  );
}

export const openMenu = MenuButton.openMenu;
export const closeMenu = MenuButton.closeMenu;
